<script>
import BaseWidgetForm from './BaseWidgetForm'
import WidgetsDialogs from '@/components/widgets/WidgetsDialogs'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  components: {
    WidgetsDialogs
  },
  beforeMount() {
    if (this.form.widgets === undefined) {
      this.$set(this.form, 'widgets', [])
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true
            }),
            new fields.Input({
              label: 'Treść',
              type: 'textarea',
              modelPath: [this, 'form', 'text']
            }),
            new fields.Switch({
              label: 'Mały',
              modelPath: [this, 'form', 'is_small']
            }),
            new fields.Widgets({
              modelPath: [this, 'form', 'widgets'],
              hiddenWidgets: ['WrapperWidget']
            })
          ]
        }
      ]
    }
  }
}
</script>
